export default "__VITE_ASSET__Ci0MpZ1V__"